import { Button } from "./_components/button";
import { Group } from "./_components/group";

export const Toggle = {
    Group,
    Button,
};

export type { GroupProps as ToggleGroupProps } from "./_components/group";
export type { ButtonProps as ToggleButtonProps } from "./_components/button";
